import React, { useState, useEffect, useContext, createContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import CreateMember from "./create/createMember";
import UpdateMember from "./update/updateMember";
import { UserContext } from "../../../App";
import axios from "axios";
import { API } from "../../../services/api";

axios.defaults.baseURL = API;

const MemberDataContext = createContext();

function Member() {

  const {userID, LocationName, showForm, setShowForm, setshowSubmenu} = useContext(UserContext);


  const [dataList, setDataList] = useState([]);
  const [ShowData, setShowData] = useState([]);
  const [Data, setData] = useState([]);

  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleCloseUpdate = () => setShowUpdate(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Search = event => {
    const { name, value } = event.target;
    if(value){
      var results = [];
      results = dataList.filter((data) => {
          return data.FirstName.toLowerCase().includes(value.toLowerCase())
      });
      if (results) 
        setShowData(results);
      else 
        setShowData(dataList);
    } else 
      setShowData(dataList);
  }

  const openUpdate = (MemberID, FirstName, LastName, MemberNO, TEL, Email, Identification) => {
    var list = [];
    list.push({
      MemberID: MemberID,
      FirstName: FirstName,
      LastName: LastName,
      MemberNO: MemberNO,
      TEL: TEL,
      Email: Email,
      Identification: Identification,
    });
    setData(list);
    setShowUpdate(true);
  };
  
  async function getAllMember() {
    let token = localStorage.getItem("token");
    axios
      .get("/getAllMember", { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        let Data = response?.data;
        setDataList(Data);
        setShowData(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleclickBack = () => {
      setShowForm(false);
      setshowSubmenu(true);
  }; 

  useEffect(() => {
    getAllMember();
  }, []);

  return (
    <MemberDataContext.Provider value={{dataList, setDataList, userID, Data, setData, setShowData}}>
      <div className="formContent">
        <CreateMember show={show} onClick={handleClose}/>
        <UpdateMember show={showUpdate} onClick={handleCloseUpdate}/>
        <div className="formCard">
        <div className="Header">
          <div className="title">
              <span>ຂໍ້ມູນບັດ Member</span>
          </div>
          <div className="buttonContent">
            <button className="btn btn-primary" onClick={handleShow} >ເພີ່ມ</button>
              <button className="btn btn-danger" onClick={() => handleclickBack()} >Back</button>
          </div>
        </div>
        <div className="Body">
           <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາ" onChange={(e) => Search(e)} />
          </div>
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>ຊື່</th>
                <th>ນາມສະກູນ</th>
                <th>MemberNO</th>
                <th>ເບີໂທ</th>
                <th>Email</th>
                <th>Identification</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                ShowData && ShowData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y+1}</td>
                        <td >{x.FirstName}</td>
                        <td >{x.LastName}</td>
                        <td >{x.MemberNO}</td>
                        <td >{x.TEL}</td>
                        <td >{x.Email}</td>
                        <td >{x.Identification}</td>
                        <td >
                          <button className="btn btn-secondary" value={x.MemberID} type="button" onClick={() => openUpdate(x.MemberID, x.FirstName, x.LastName, x.MemberNO, x.TEL, x.Email, x.Identification)}>ແກ້ໄຂ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
        </div>
      </div>
    </MemberDataContext.Provider>
  );
};

export {MemberDataContext};
export default Member;
